<div
  class="d-flex position-relative bg-dark border border-darkgray z-1 shadow-sm rounded-2 align-items-center text-gray p-2 px-3 min-wpx-100"
>
  <ng-content></ng-content>
</div>
